export const products = [
  {
    id: 'dossier',
    name: 'Dossier Compiler',
    description: 'CTD structure, offline-first dossier assembly',
    features: [
      'CTD-compliant document structure',
      'Offline-first functionality',
      'Regulatory guidance integration'
    ],
    status: 'live',
    url: process.env.REACT_APP_DOSSIER_URL,
    external: true
  },
  {
    id: 'school',
    name: 'ProgrammoCeuticals School',
    description: 'Structured cohorts, curriculum-driven learning',
    features: [
      'Interactive coding challenges',
      'Structured learning paths',
      'Progress tracking and certificates'
    ],
    status: 'live',
    url: process.env.REACT_APP_SCHOOL_URL,
    external: true
  },
  {
    id: 'regulations',
    name: 'Regulations Hub',
    description: 'Regulatory guidance & document intake',
    features: [
      'Regulatory compliance workflows',
      'Document analysis and validation',
      'Regulatory requirement mapping'
    ],
    status: 'live',
    url: process.env.REACT_APP_REGULATIONS_URL,
    external: true
  }
];
